import * as Yup from "yup";
const richCard = {
  imageUrl: Yup.string().test(
    "required-imageUrl",
    "La URL de la imagen es requerida para RCS Avanzado",
    function (value) {
      return this.parent.step === 2 ? !!value : true;
    },
  ),
  cardOrientation: Yup.string().test(
    "required-cardOrientation",
    "La orientación de la imagen es requerida para RCS Avanzado",
    function (value) {
      return this.parent.step === 2 ? !!value : true;
    },
  ),
  height: Yup.string().test(
    "required-height",
    "La altura de la imagen es requerida para RCS Avanzado",
    function (value) {
      return this.parent.step === 2 ? !!value : true;
    },
  ),
};

const actions = {
  buttonActions: Yup.array()
    .of(
      Yup.lazy((value) => {
        const type = value?.type;
        const baseShape = {
          type: Yup.string().required(
            "El tipo de botón de acción es requerido",
          ),
          text: Yup.string()
            .min(
              3,
              "El texto del botón de acción debe tener al menos 3 caracteres",
            )
            .max(
              25,
              "El texto del botón de acción debe tener menos de 25 caracteres",
            )
            .required("El texto del botón de acción es requerido"),
        };
        switch (type) {
          case "openUrlAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .url("Ingresa una URL válida")
                .required("La URL de la acción es  requerida"),
              application: Yup.string().nullable(),
              webview: Yup.string().nullable(),
              description: Yup.string().nullable(),
            });

          case "openUrlActionShortLink":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .url("Ingresa una URL de acción válida")
                .required("La URL de la acción es requerida"),
            });

          case "ViewLocationAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
              lat: Yup.number()
                .typeError("La latitud de la ubicación debe ser un número")
                .test(
                  "required-lat",
                  "La latitud de la ubicación debe estar en un rango de [-90, 90]",
                  function (value) {
                    return value >= -90 && value <= 90;
                  },
                )
                .required("La latitud de la ubicación es requerida"),
              long: Yup.number()
                .typeError("La longitud de la ubicación debe ser un número")
                .test(
                  "required-long",
                  "La longitud debe estar en un rango de [-180, 180]",
                  function (value) {
                    return value >= -180 && value <= 180;
                  },
                )
                .required("La Longitud de la ubicación es requerida"),
            });
          case "dialAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string()
                .matches(
                  /^(?:\d{10}|[*#]\d{2,5})$/,
                  "Debe ser un número de 10 dígitos o un número corto que empiece con * o #",
                )
                .required("El número de telefono es requerido"),
            });

          case "createCalendarEventAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
              title: Yup.string()
                .min(3, "Título del evento demasiado corto")
                .max(50, "Título del evento demasiado largo")
                .required("El título del evento es requerido"),
              startTime: Yup.date().required("Inicio requerido para el evento"),
              endTime: Yup.date()
                .min(
                  Yup.ref("startTime"),
                  "La fecha final del evento debe ser posterior",
                )
                .required("Fin requerido"),
              description: Yup.string()
                .min(3, "La descripción del evento es demasiado corta")
                .max(100, "La descripción del evento es demasiado larga")
                .nullable(),
            });

          case "ShareLocationAction":
            return Yup.object().shape({
              ...baseShape,
              action: Yup.string().nullable(),
            });

          default:
            return Yup.object().shape(baseShape);
        }
      }),
    )
    .when("step", {
      is: (step) => step === 2 || step === 3,
      then: (schema) =>
        schema.max(
          4,
          "El máximo de acciones es 4, elimina alguna para continuar",
        ),
      otherwise: (schema) =>
        schema.max(
          10,
          "El máximo de acciones es 10, elimina alguna para continuar",
        ),
    }),
};

const replies = {
  buttonQuickReplies: Yup.array()
    .of(
      Yup.object().shape({
        type: Yup.string().required(
          "El tipo de botón de respuesta es requerido",
        ),
        action: Yup.string().required(
          "La acción del botón de respuesta es requerida",
        ),
        text: Yup.string()
          .min(1)
          .max(25, "El texto debe tener menos de 25 caracteres")
          .required("El texto del botón de respuesta es requerido"),
      }),
    )
    .when("step", {
      is: (step) => step === 2 || step === 3,
      then: (schema) =>
        schema.max(
          4,
          "El máximo de sugerencias es 4, elimina alguna para continuar",
        ),
      otherwise: (schema) =>
        schema.max(
          10,
          "El máximo de sugerencias es 11, elimina alguna para continuar",
        ),
    }),
};

const carrousel = {
  carrousel: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string()
          .min(3, "El título del carrousel debe tener al menos 3 caracteres")
          .max(
            100,
            "El título del carrousel no puede tener más de 100 caracteres",
          )
          .required("El título del carrousel es requerido"),
        description: Yup.string()
          .min(
            3,
            "La descripción del carrousel debe tener al menos 3 caracteres",
          )
          .max(
            200,
            "La descripción del carrousel no puede tener más de 100 caracteres",
          )
          .required("La descripción del carrousel es requerida"),
        imageUrl: Yup.string()
          .url("Ingresa una URL válida")
          .test(
            "required-imageUrl",
            "La URL de la imagen es requerida para RCS Carrousel",
            function (value) {
              return !!value;
            },
          ),
        height: Yup.string().test(
          "required-height",
          "La altura de la imagen es requerida para RCS Carrousel",
          function (value) {
            return !!value;
          },
        ),
        ...actions,
        ...replies,
      }),
    )
    .when("$step", {
      is: 3,
      then: (schema) =>
        schema
          .min(2, "Debe haber al menos 2 elementos en el carrusel")
          .max(10, "Máximo 10 elementos"),
      otherwise: (schema) => schema.notRequired(),
    }),
};
const general = {
  campaignName: Yup.string()
    .min(3, "El nombre de la campaña debe tener al menos 3 caracteres")
    .required("El nombre de la campaña es requerido"),
  uiddatabase: Yup.string().required("La base de datos es requerida"),
  idshorcodemask: Yup.string(),
  mask: Yup.string(),
  isRcs: Yup.boolean(),
  isSms: Yup.boolean(),
  isScheduled: Yup.boolean(),
  message: Yup.string()
    .min(3, "El mensaje SMS debe tener al menos 3 caracteres")
    .max(399, "El mensaje SMS no puede tener más de 399 caracteres")
    .test("required-message", "El mensaje SMS es requerido", function (value) {
      return this.parent.isSms ? !!value : true;
    }),
  title_rcs_message: Yup.string()
    .min(3, "El título rcs debe tener al menos 3 caracteres")
    .max(200, "El título rcs no puede tener más de 200 caracteres")
    .test("required-message", "El título rcs es requerido", function (value) {
      return this.parent.step === 2 && this.parent.isRcs ? !!value : true;
    }),
  rcsmessage: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(2000, "El mensaje no puede tener más de 2000 caracteres")
    .test("required-message", "El mensaje rcs es requerido", function (value) {
      return [1, 2].includes(this.parent.step) && this.parent.isRcs
        ? !!value
        : true;
    }),
  fallback: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(398, "El mensaje no puede tener más de 399 caracteres")
    .test("required-message", "El fallback rcs es requerido", function (value) {
      return this.parent.isRcs ? !!value : true;
    }),

  email_message: Yup.string()
    .min(3, "El mensaje de correo es demasiado corto")
    .test(
      "required-email_message",
      "El mensaje del correo es requerido",
      function (value) {
        const stripHtml = (message = "") =>
          message.replace(/<[^>]*>/g, "").trim();

        if (!this.parent.isEmail) return true;

        return stripHtml(value).length > 0;
      },
    ),

  email_subject: Yup.string()
    .min(3, "El mensaje de correo es demasiado corto")
    .test(
      "required-email_subject",
      "El asunto del correo es requerido",
      function (value) {
        return this.parent.isEmail ? !!value : true;
      },
    ),
  dateSend: Yup.string().test(
    "required-dateSend",
    "La fecha de envio es requerido",
    function (value) {
      return this.parent.isScheduled ? !!value : true;
    },
  ),
  proghour: Yup.string().test(
    "required-proghour",
    "La hora de envio es requerido",
    function (value) {
      return this.parent.isScheduled ? !!value : true;
    },
  ),
};

export const validationSchema = Yup.object({
  ...general,
  ...richCard,
  ...actions,
  ...replies,
  ...carrousel,
});
